import { useQuery } from "react-query";
import { useAuth } from "../../auth/hooks";
import { extractAPI } from "../services/extractAPI";
import { ExtractGroup } from "../types/extract.types";

// Hooks for the static extract catalog (groups + configs).
//
// The legacy useExtract() hook that drove the synchronous SSE flow lived
// here too; it was retired when the async jobs flow took over (the form
// now submits via useCreateExtractJob and the list via useExtractJobsList).
export function useExtractGroups() {
  const { setHeaderAuthToRequest, getUserIsAuthenticated } = useAuth();
  setHeaderAuthToRequest();

  return useQuery<ExtractGroup[]>("extractGroups", extractAPI.getExtractGroups, {
    staleTime: 1000 * 60 * 30,
    enabled: getUserIsAuthenticated(),
  });
}
